module.exports = __webpack_public_path__ + "static/media/tutorials-icon.bb3d62ae.svg";